module.exports = __webpack_public_path__ + "static/media/phsParshaBW.0e4b8eca.jpg";